// Copyright 2025, University of Maryland, All Rights Reserved
import { useState, useEffect } from 'react';
import { Alert, AlertDescription } from '@/components/ui';
import { AlertTriangle } from 'lucide-react';
import { authEvents } from '../../services/api';

export function AuthErrorAlert() {
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    // Subscribe to auth error events using our React-friendly system
    const unsubscribe = authEvents.onAuthError((event) => {
      setAuthError(event.message || 'Authentication error occurred');
      
      // Auto-hide after 5 seconds
      setTimeout(() => {
        setAuthError(null);
      }, 5000);
    });
    
    return () => {
      // Clean up subscription
      unsubscribe();
    };
  }, []);

  if (!authError) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>
        {authError}
      </AlertDescription>
    </Alert>
  );
}
